import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, IconButton, SelectChangeEvent } from '@mui/material';
import { useUploadURL } from '@stores/UploadURL/UploadURLStore';
import { observer } from 'mobx-react-lite';
import { FilterButton } from './FilterButton';
import { HeaderMessage, HeaderStatusMessages } from './HeaderStatusMessages';
import css from './MediaDataGrid.module.scss';
import { SortOption, SortSelector } from './SortSelector';

interface MediaDataGridHeaderProps {
  activeFilterCount: number;
  isFiltersPopoverOpen: boolean;
  onFiltersButtonClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  sortOption: SortOption;
  onSortChange: (event: SelectChangeEvent<SortOption>) => void;
  headerMessages: HeaderMessage[];
  onShowAll: () => void;
}

export const MediaDataGridHeader = observer(
  ({
    activeFilterCount,
    isFiltersPopoverOpen,
    onFiltersButtonClick,
    sortOption,
    onSortChange,
    headerMessages,
    onShowAll,
  }: MediaDataGridHeaderProps) => {
    const store = useUploadURL();
    const hasMessages = headerMessages.length > 0;

    // Determine info button color from highest-priority status present
    const infoColorClass = headerMessages.some((m) => m.type === 'error')
      ? css.headerStatusInfoError
      : headerMessages.some((m) => m.type === 'warning')
        ? css.headerStatusInfoWarning
        : headerMessages.some((m) => m.type === 'in-library')
          ? css.headerStatusInfoInLibrary
          : undefined;

    return (
      <>
        <Box className={css.filtersToolbar}>
          <div className={css.filtersToolbarLeft}>
            <FilterButton
              activeFilterCount={activeFilterCount}
              isOpen={isFiltersPopoverOpen}
              onClick={onFiltersButtonClick}
            />
            {store.statusDismissed && hasMessages && (
              <IconButton
                className={`${css.headerStatusInfoButton} ${infoColorClass ?? ''}`}
                onClick={() => store.setStatusDismissed(false)}
                size="small"
              >
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>
            )}
          </div>
          <SortSelector sortOption={sortOption} onChange={onSortChange} />
        </Box>
        {!store.statusDismissed && (
          <HeaderStatusMessages
            messages={headerMessages}
            onDismiss={() => store.setStatusDismissed(true)}
            onShowAll={onShowAll}
          />
        )}
      </>
    );
  },
);

MediaDataGridHeader.displayName = 'MediaDataGridHeader';
